import { createEntity } from '@luna/api';
import type { GetCustomizationResponse } from '@api-client/products';
import { CustomizationService } from '@api-client/products';

export const customizationEntity = createEntity({
    name: '@products/aggregation/customizations',
    withEntityType: {} as GetCustomizationResponse,
    payloadCreators: {
        queryById: async (id: string): Promise<GetCustomizationResponse> =>
            CustomizationService.getPublicProductsCustomization({
                id,
            }),
    },
});
